/**
*
* getSubTopics
*
*/

import { idList, idObject } from 'utils/arrays.js';

/**
 *
 * @param {object} original input state
 * @param {object} topic, if present, only get subTopics for this topic
 * @param {boolean} insert, insert subtopics in list property
 * @returns
 */
// function getSubTopics_org(state, topic) {
//   let result = state;
//   const { id } = topic;
//   result = result.mergeIn([id], fromJS(topic));
//   const { subTopics, subTopicIds } = result.get(id).toJS();
//   if (subTopics && !subTopicIds) {
//     result = result
//       .setIn([id, 'subTopicIds'], fromJS(idList(subTopics)))
//       .merge(idObject(subTopics));
//   }
//   return result;
// }

/**
 *
 * @param {object} topics
 * @param {object} topic, if present, only get subTopics for this topic
 * @returns
 */
function getSubTopics(topics, topic) {
  const { id } = topic;
  const result = {
    ...topics,
    [id]: { ...topics[id], ...topic },
  };
  const { subTopics } = result[id];
  if (subTopics) {
    result[id].subTopicIds = idList(subTopics);
    return {
      ...result,
      ...idObject(subTopics),
    };
  }
  return result;
}

export default getSubTopics;
